import { FC, useEffect, useState } from 'react';
import {
    CalendarBackgroundModal,
    CalendarContainer,
    CalendarModalWrapper,
} from './styles';

import { BigButton } from '../BigButton';
import { CustomReactCalendar } from './CustomReactCalendar';
import animations from '../../helpers/animations';
import { Checkbox } from '../Checkbox';
import moment from 'moment';

export interface CalendarProps {
    onClose?: (value: Date | null) => void;
    defaultDate?: Date | null;
    pricesProductId?: string;
    shouldAllowUndecidedDate?: boolean;
    minDate?: Date;
    maxDate?: Date;
}

const fridayStr: string =
    import.meta.env.VITE_NOT_DECIDED_DATE_FRIDAY || '2030-01-25';
const friday = moment(fridayStr, 'YYYY-MM-DD').toDate();
const saturday = moment(friday).add(1, 'day').toDate();

export const isUndecidedDate = (date: Date) => {
    return false;
    // return moment(date).isSame(friday, 'day') || moment(date, 'day').isSame(saturday);
};

export const Calendar: FC<CalendarProps> = ({
    onClose,
    defaultDate,
    pricesProductId,
    shouldAllowUndecidedDate,
    minDate,
    maxDate,
}) => {
    const [forceViewDate, setForceViewDate] = useState<number>(0);
    const [value, setValue] = useState<Date>(defaultDate || new Date());
    const [isNotDecided, setIsNotDecided] = useState(isUndecidedDate(value));
    const [isWeekend, setIsWeekend] = useState(moment(value).isSame(saturday));

    useEffect(() => {
        if (isNotDecided) {
            if (isWeekend) {
                return setValue(saturday);
            }

            return setValue(friday);
        }

        setValue(new Date());
        setForceViewDate(e => e + 1);
    }, [isNotDecided, isWeekend]);

    return (
        <CalendarBackgroundModal
            onClick={e => {
                e.stopPropagation();
                onClose && onClose(defaultDate || null);
            }}
            {...animations.calendar}
        >
            <CalendarModalWrapper onClick={e => e.stopPropagation()}>
                <CalendarContainer>
                    <h2 className="title">Calendário</h2>
                    {/* <PseudoCalendar
                        onNext={modifyValueInDays(1)}
                        onPrevious={modifyValueInDays(-1)}
                        date={value!}
                    /> */}
                    <CustomReactCalendar
                        setValue={setValue}
                        value={value}
                        pricesProductId={pricesProductId}
                        ignoreBasicValidation={true}
                        forceViewDate={forceViewDate}
                        isHeadless={isNotDecided}
                        minDate={minDate}
                        maxDate={maxDate}
                    />
                    <div className="line-divider"></div>
                    {shouldAllowUndecidedDate && (
                        <>
                            <div className="checkbox-wrapper">
                                <Checkbox
                                    statusCheck={isNotDecided}
                                    onClickCheck={() =>
                                        setIsNotDecided(e => !e)
                                    }
                                    descriptionCheck="Ainda não sei a data"
                                />
                                {isNotDecided && (
                                    <div className="row">
                                        <Checkbox
                                            statusCheck={!isWeekend}
                                            onClickCheck={() =>
                                                setIsWeekend(false)
                                            }
                                            descriptionCheck="Meio de semana"
                                        />

                                        <Checkbox
                                            statusCheck={isWeekend}
                                            onClickCheck={() =>
                                                setIsWeekend(true)
                                            }
                                            descriptionCheck="Final de semana"
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="line-divider"></div>
                        </>
                    )}
                    <div className="buttons-wrapper">
                        <BigButton
                            color="secondary-alt"
                            bgColor="secondary"
                            children={'Cancelar'}
                            onClick={e => {
                                e.stopPropagation();
                                if (onClose) onClose(defaultDate || null);
                            }}
                        />
                        <BigButton
                            color="primary"
                            bgColor="primary"
                            children={'Salvar'}
                            onClick={e => {
                                e.stopPropagation();
                                if (onClose) onClose(value);
                            }}
                        />
                    </div>
                </CalendarContainer>
            </CalendarModalWrapper>
        </CalendarBackgroundModal>
    );
};
